import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [20,[2],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-access": [29,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/activity": [30,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-activity/banking-information": [31,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/tax-election": [32,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/entity/type": [33,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/joint": [34,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/account": [35,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/beneficiary-inherited": [36,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/decedent-name": [37,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/retirement/individual": [38,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/account-type/select": [39,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiaries": [40,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-address": [41,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-details": [42,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/beneficiary-name": [43,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/trust-beneficiary": [44,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/add-beneficiaries/type-of-beneficiary": [45,[2,4,8,9,10],[3]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/estate-percentage-allocation": [46,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/additional-information/secondary-owner": [47,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/investment-time-horizon": [48,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/business-preferences/risk-tolerance": [49,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/cryptocurrency-trading": [50,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/financial-information": [51,[2,4,8,9,11],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/instruments-knowledge": [52,[2,4,8,9,11],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-experience/trading-objective": [53,[2,4,8,9,11],[3]],
		"/(app)/(wizard)/(pre-submission)/account/trading-method": [54,[2,4,8,9],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/foreign-financial-institution": [55,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/legal-exemption": [56,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/affiliation/select": [57,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-address": [58,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-details": [59,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-name": [60,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owner-tax-info": [61,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/beneficial-owners-table": [62,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/confirm-none": [63,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/individual": [64,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-entity": [65,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/beneficial-owners/other-individual": [66,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/basics": [67,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/company-secretary": [68,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/mailing-address": [69,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/primary-address": [70,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/information/same-mailing-address": [71,[2,4,8,12],[3]],
		"/(app)/(wizard)/(pre-submission)/business/relationship": [72,[2,4,8,12],[3]],
		"/(session)/confirmation": [120,[19]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload": [73,[2,4,8,13,14],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/address-opt-out": [74,[2,4,8,13,14],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/confirm": [75,[2,4,8,13,14],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/entity-upload": [76,[2,4,8,13,14],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/documents-upload/upload": [77,[2,4,8,13,14],[3]],
		"/(app)/(wizard)/(pre-submission)/documents/important-documents": [78,[2,4,8,13],[3]],
		"/(app)/done/auto-approved": [115,[2,18],[3]],
		"/(app)/done/documents-required": [116,[2,18],[3]],
		"/(app)/done/joint-continuation": [117,[2,18],[3]],
		"/(app)/done/needs-review": [118,[2,18],[3]],
		"/(app)/error": [119,[2],[3]],
		"/(session)/joint-continuation-signup": [121,[19]],
		"/(session)/joint-continuation-signup/success": [122,[19]],
		"/(session)/login": [123,[19]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/industry": [79,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/political": [80,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/public-company": [81,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/affiliation-information/select": [82,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/citizenship": [83,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/documents-to-prepare": [84,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/foreign-citizenship": [85,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/residency": [86,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/citizenship-status/visa": [87,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/mailing-address": [88,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/name": [89,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/phone-number": [90,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/physical-address": [91,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/contact-information/same-address": [92,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/employment-status": [93,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/employment-information/job-details": [94,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/birth-date": [95,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/family": [96,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/subject-to-tax-withholding": [97,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/personal-info/tax-information/tax-number": [98,[2,4,8,15],[3]],
		"/(app)/(wizard)/(pre-submission)/security/confirm-identity": [99,[2,4,8,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/security-question": [100,[2,4,8,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/authenticator": [101,[2,4,8,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/method-selection": [102,[2,4,8,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/setup": [103,[2,4,8,16],[3]],
		"/(app)/(wizard)/(pre-submission)/security/two-factor-auth/sms": [104,[2,4,8,16],[3]],
		"/(app)/(wizard)/(post-submission)/setup/cryptocurrency-trading": [21,[2,4,5,6],[3]],
		"/(app)/(wizard)/(post-submission)/setup/funding/deposit": [22,[2,4,5,6],[3]],
		"/(app)/(wizard)/(post-submission)/setup/funding/link-bank": [23,[2,4,5,6],[3]],
		"/(app)/(wizard)/(post-submission)/setup/sms-notifications": [24,[2,4,5,6],[3]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/add-trusted-contact": [25,[2,4,5,6,7],[3]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/address": [26,[2,4,5,6,7],[3]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/contact-info": [27,[2,4,5,6,7],[3]],
		"/(app)/(wizard)/(post-submission)/setup/trusted-contact/personal-info": [28,[2,4,5,6,7],[3]],
		"/(session)/signup": [124,[19]],
		"/(session)/signup/account-type": [125,[19]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/foreign-financial-institution": [105,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/affiliation/select": [106,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor-details": [108,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/grantor-information/grantor": [107,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/basics": [109,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/mailing-address-details": [110,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/primary-address": [111,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/information/same-mailing-address": [112,[2,4,8,17],[3]],
		"/(app)/(wizard)/(pre-submission)/trust/review": [113,[2,4,8,17],[3]],
		"/(app)/[...catchAll]": [114,[2],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';